export default __webpack_public_path__ + "static/media/kitchen3-afterF-480w.c920e5b5.png";